import { Layout } from "./components"
import { AppProvider } from "./context"
import { Router } from "./router"
import './styles/scrollbar.css'
import { SoundProvider } from './components/SoundProvider';
import { ToastContainer } from 'react-toastify';


function App() {

  return (
    <AppProvider>
      <Layout >
        <SoundProvider>
          <ToastContainer />
          <Router />
        </SoundProvider>
      </Layout>
    </AppProvider>
  )
}

export default App